export default __webpack_public_path__ + "static/media/a1.99d22960.png";